import React, { useContext, useEffect, useState } from 'react'
import AuthContext from '../Contexts/AuthContext'
import { goingEventService, listGoingEventsService, notGoingEventService } from '../Service/EventService'
import { Calendar } from 'primereact/calendar'
import PaginatorComponent from './PaginatorComponent'
import { Button } from 'primereact/button'
import { Panel } from 'primereact/panel'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import AppBodyComponent from './AppBodyComponent'
import { PiCheckCircleBold, PiXCircleBold } from 'react-icons/pi'

function UserHomeEventsComponent() {

    const { t } = useTranslation('user_home');
    const navigate = useNavigate()
    const {userAuth, setActiveMenu} = useContext(AuthContext)
    const [events, setEvents] = useState()
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(1)
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date(Date.now() + 30 * 24 * 60 * 60 * 1000))

    useEffect(()=>{
        setActiveMenu(1)
    },[])

    useEffect(()=>{
        listGoingEvents()
    },[page])

    const listGoingEvents = () =>{
        userAuth?.user?.access_key && listGoingEventsService(userAuth?.user?.access_key, page, startDate, endDate).then(res=>{
            setEvents(res.rows)
            setTotal(res.pages)
        })
    }

    const handleGoing = (going, access_key) => {
        going ? notGoingEventService(going).then(res=>{
            res && listGoingEvents()
        }) : goingEventService(userAuth?.user?.access_key, access_key).then(res=>{
            res.id && listGoingEvents()
        })    
    }

    return (
        <AppBodyComponent>
        <div className='flex flex-column gap-4 w-full'>
            <div className='font-bold text-xl'>{t('user_home_event_page_title')}</div>
            <div className='flex flex-column gap-2 w-full'>
                <div className='flex gap-2 align-items-end'>
                    <div className='flex flex-column gap-1'>
                        <span>{t('user_home_event_start_date')}</span>
                        <Calendar className='w-7rem md:w-12rem' value={new Date(startDate.toLocaleDateString())} onChange={(e)=>setStartDate(new Date(e.target.value))} />
                    </div>
                    <div className='flex flex-column gap-1'>
                        <span>{t('user_home_event_end_date')}</span>
                        <Calendar className='w-7rem md:w-12rem' value={new Date(endDate.toLocaleDateString())} onChange={(e)=>setEndDate(new Date(e.target.value))} />
                    </div>
                    <Button className='h-max' label={t('user_home_event_filter_button')} onClick={listGoingEvents} />
                </div>
            {events && events.length > 0 ? 
                <div className='flex flex-column gap-2'>
                    {events.map((item, key)=>(
                        <Panel key={key} className='flex flex-column gap-2'>
                            <div className='flex justify-content-between align-items-center'>
                                <span>{item.title}</span>
                            </div>
                            <div className='text-sm flex gap-1'>
                                <span className='font-bold'>{t('user_home_event_place')}: </span>
                                <span>{item.place_name}</span>
                            </div>
                            <div className='text-sm flex gap-1'>
                                <span className='font-bold'>{t('user_home_event_address')}: </span>
                                <span>{item.address}</span>
                            </div>
                            <div className='flex gap-1 text-sm'>
                                <span className='font-bold'>{t('user_home_event_date')}: </span>
                                <span>{new Date(item.date_start).toLocaleDateString()}</span>
                                <span>{new Date(new Date().toLocaleDateString() +' '+ item.time_start).toLocaleTimeString()}</span>
                                <span className='font-bold'> - </span>
                                <span>{new Date(item.date_end).toLocaleDateString()}</span>
                                <span>{new Date(new Date().toLocaleDateString() +' '+ item.time_end).toLocaleTimeString()}</span>
                            </div>
                            <div className='text-sm'>
                                {item.description.length >= 30 ? item.description.substring(0, 30)+' ...' : item.description}
                            </div>
                            
                            <div className='flex flex-column gap-2'>
                                {item.going ? 
                                <div className='flex text-green-500 gap-1 align-items-center'><PiCheckCircleBold /> {t('calendar_component_going_message')}</div> :
                                <div className='flex text-red-500 gap-1 align-items-center'><PiXCircleBold /> {t('calendar_component_not_going_message')}</div>}
                                
                                <Button rounded className='w-max' onClick={()=>handleGoing(item.going, item.access_key)} label={item.going ? t('calendar_component_not_going_button') : t('calendar_component_going_button')} icon={item.going ? 'pi pi-times' : 'pi pi-check'} severity={item.going ? 'danger' : 'success'} />
                            </div>
                        </Panel>
                    ))}
                    <PaginatorComponent page={page} setPage={setPage} total={total} />
                </div>
                : 
                <div className='flex flex-column gap-4 align-items-center mt-4'>
                    <div className='text-xl font-bold text-center'>{t('user_home_noevent_title')}</div>    
                    <div className='text-center'>{t('user_home_noevent_message')}</div>    
                    <Button className='w-max' label={t('user_home_noevent_button')} onClick={()=>navigate('/app/place_list')} />
                </div>}
            </div> 
        </div>
        </AppBodyComponent>
    )
}

export default UserHomeEventsComponent